// ─── Advisor sign-in ──────────────────────────────────────────────────────────
//
// This app is internal and it is deployed publicly. Until this existed, the only
// key the browser held was the public anon key — and jbf_cases granted anon
// select, insert AND update, so possession of the URL was possession of every
// client case in the table.
//
// Same Supabase project as the Personal Paycheck Account, so the same login works
// in both and there is no second account to keep.

import React, { useState } from 'react';
import './SignIn.css';
import { supabase } from './supabaseClient';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setBusy(false);
    // Never distinguish "no such user" from "wrong password" — that difference
    // tells an outsider which addresses are real.
    if (error) setErr('That email and password did not match.');
  };

  return (
    <div className="si">
      <form className="si-box" onSubmit={submit}>
        <div className="si-brand">J Bradin Financial<b>Retirement Planner</b></div>
        <label>Email
          <input type="email" autoComplete="username" value={email}
                 onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>Password
          <input type="password" autoComplete="current-password" value={password}
                 onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <button type="submit" disabled={busy || !email || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        {err && <p className="si-err">{err}</p>}
        <p className="si-note">Advisor access only. This tool holds client data.</p>
      </form>
    </div>
  );
}
